import React from "react";

export const MeetingContext = React.createContext(null);